import {
  CoverageFeeProductMatchType,
  isCoverageFeeProduct,
} from "./is-coverage-fee-product";

interface CheckIsRedoLineItem {
  sku?: string | null;
  vendor?: string | null;
  name?: string;
  title?: string;
}

export const isRedoLineItem = (lineItem: CheckIsRedoLineItem | undefined) => {
  if (!lineItem) {
    return false;
  }
  const title = "title" in lineItem ? lineItem.title : lineItem.name;
  return isCoverageFeeProduct({
    product: { vendor: lineItem.vendor, sku: lineItem.sku, title },
    matchType: CoverageFeeProductMatchType.REDO_AND_COMPETITORS,
  });
};
